import { ServiceTypes } from 'constants/ServiceTypes';
import { ReactComponent as RecordingIcon } from 'images/recordingIcon.svg';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { SessionStore } from 'stores/SessionStore';
import { CurrentState, Tile, Title } from './PlayVideoStyles';

export const PlayVideo: React.FC = observer(() => {
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);

  return (
    <Tile>
      <Title>Play video</Title>
      {sessionStore.currentSessionMode.isVideoCaptureEnabled ? (
        <>
          <CurrentState>
            <RecordingIcon />
            <div>Recording</div>
          </CurrentState>
        </>
      ) : (
        <CurrentState>Not recording</CurrentState>
      )}
    </Tile>
  );
});
